const ARCHIVE_LIST_TYPES = ['customer_archive', 'supplier_archive', 'archive_rfq', 'archive_quote'];

/**
 * True when the selection should restore records instead of archiving them.
 * An archived type list is already all archived. Include Archive on a live list
 * mixes both, so the button follows the selected rows.
 */
export function selectionUnarchives(filterValue, rows) {
  if (ARCHIVE_LIST_TYPES.includes(filterValue)) return true;
  const originals = (rows || []).map((row) => row?.original).filter(Boolean);
  return originals.length > 0 && originals.every((row) => row.is_archive === true);
}
